const dataInsertedHooks = [];

function registerHook(list, fn) {
    list.push(fn);

    return () => {
        const i = list.indexOf(fn);
        if (i > -1) {
            list.splice(i, 1);
        }
    };
}

export function dataInserted(fn) {
    return registerHook(dataInsertedHooks, fn);
}

export function triggerDataInserted() {
    dataInsertedHooks.forEach(fn => fn());
}



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/router/data-inserted-hook.js